import React from 'react'
import ProductListPage from 'pages/buffet/ProductList'
import ProductDetailPage from 'pages/buffet//ProductDetail'
import PrivateCartPage from 'pages/buffet/PrivateCart'
import GlobalCartPage from 'pages/buffet/GlobalCart'
import CheckoutPage from 'pages/buffet/Checkout'
import PaymentMethodPage from 'pages/buffet/PaymentMethod'
import PromotionPage from 'pages/buffet/Promotion'
import ShareCoupon from 'pages/buffet/ShareCoupon'
import InviteFriends from 'pages/buffet/InviteFriends'
import ConfirmShareCoupon from 'pages/buffet/ConfirmShareCoupon'

interface BuffetPage {
  path: string
  component: React.ComponentType
}

export const basePath = '/buffet'

export enum BuffetPath {
  Home = '/',
  ProductDetail = '/product/:categoryID/:productID',
  PrivateCart = '/private-cart',
  GlobalCart = '/global-cart',
  Checkout = '/checkout',
  PaymentMethod = '/select-payment-method',
  Promotions = '/promotions',
  ShareCoupon = '/share-coupon',
  InviteFriends = '/invite-friends',
  ConfirmShareCoupon = '/confirm-share-coupon',
}

type BuffetFullPathType = {
  [K in keyof typeof BuffetPath]: string
}

export const BuffetFullPath: BuffetFullPathType = {} as BuffetFullPathType
Object.keys(BuffetPath).forEach((key) => {
  const fullPath = `${basePath}${BuffetPath[key]}`
  BuffetFullPath[key] = fullPath
})

const buffetPages: BuffetPage[] = [
  { path: BuffetPath.Home, component: ProductListPage },
  { path: BuffetPath.ProductDetail, component: ProductDetailPage },
  { path: BuffetPath.PrivateCart, component: PrivateCartPage },
  { path: BuffetPath.GlobalCart, component: GlobalCartPage },
  { path: BuffetPath.Checkout, component: CheckoutPage },
  { path: BuffetPath.PaymentMethod, component: PaymentMethodPage },
  { path: BuffetPath.Promotions, component: PromotionPage },
  { path: BuffetPath.ShareCoupon, component: ShareCoupon },
  { path: BuffetPath.InviteFriends, component: InviteFriends },
  { path: BuffetPath.ConfirmShareCoupon, component: ConfirmShareCoupon },
]

export default buffetPages
